 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907":"account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907","account-settings-idea-collection":"account-settings-idea-collection","settings":"settings","account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715":"account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715","account-settings-my-profile~admin-home":"account-settings-my-profile~admin-home","account-settings-my-profile":"account-settings-my-profile","admin-home":"admin-home","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349":"business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6":"business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6","business-guide-concept-distribution":"business-guide-concept-distribution","business-guide-concept-partners":"business-guide-concept-partners","business-guide-concept-product":"business-guide-concept-product","business-guide-concept-promotion":"business-guide-concept-promotion","business-guide-projections-direct-costs":"business-guide-projections-direct-costs","business-guide-projections-marketing-budget":"business-guide-projections-marketing-budget","business-guide-projections-other-overheads":"business-guide-projections-other-overheads","business-guide-projections-revenue-streams":"business-guide-projections-revenue-streams","business-guide-research-competitors":"business-guide-research-competitors","business-guide-research-customers":"business-guide-research-customers","business-guide-set-up-financing":"business-guide-set-up-financing","business-guide-set-up-staff-and-payroll":"business-guide-set-up-staff-and-payroll","business-guide-set-up-startup-costs":"business-guide-set-up-startup-costs","financial-plan-expenses-direct-costs":"financial-plan-expenses-direct-costs","financial-plan-expenses-marketing-costs":"financial-plan-expenses-marketing-costs","financial-plan-expenses-other-overheads":"financial-plan-expenses-other-overheads","financial-plan-expenses-payroll-expenses":"financial-plan-expenses-payroll-expenses","financial-plan-expenses-startup-costs":"financial-plan-expenses-startup-costs","financial-plan-financing":"financial-plan-financing","financial-plan-profit-and-cash-flow":"financial-plan-profit-and-cash-flow","financial-plan-revenue":"financial-plan-revenue","business-guide-research-market~financial-plan~payment-login~select-idea-new":"business-guide-research-market~financial-plan~payment-login~select-idea-new","payment-login":"payment-login","select-idea-new":"select-idea-new","home~idea-settings~select-idea":"home~idea-settings~select-idea","home":"home","idea-settings":"idea-settings","select-idea":"select-idea","business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965":"business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965","business-guide-set-up-management-team":"business-guide-set-up-management-team","login~signup~verification":"login~signup~verification","login":"login","verification":"verification","signup":"signup","reset-password":"reset-password","business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551":"business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551","business-plan-shared":"business-plan-shared","business-guide-concept-idea":"business-guide-concept-idea","business-guide-projections-profit-and-cash-flow":"business-guide-projections-profit-and-cash-flow","business-guide-research-market-potential":"business-guide-research-market-potential","business-plan":"business-plan","financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared":"financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared","financial-plan-overview":"financial-plan-overview","financial-plan-shared":"financial-plan-shared","financial-plan":"financial-plan","business-guide-ownership":"business-guide-ownership","business-guide-research-market":"business-guide-research-market","idea-plan~shared-journal":"idea-plan~shared-journal","idea-plan":"idea-plan","business-guide":"business-guide","validation-idea-score~validation-idea-score-test":"validation-idea-score~validation-idea-score-test","validation-idea-score":"validation-idea-score","validation-idea-score-test":"validation-idea-score-test","ai-assistance":"ai-assistance","app-sumo-signup":"app-sumo-signup","billing":"billing","financial-plan-expenses-total-costs":"financial-plan-expenses-total-costs","shared-journal":"shared-journal","dealify-signup":"dealify-signup","idea-home":"idea-home","invited-users":"invited-users","product-tour":"product-tour"}[chunkId]||chunkId) + "." + {"404":"b40f8deb","account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907":"de1f6fbf","account-settings-idea-collection":"34e577af","settings":"3ae467fb","account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715":"549411c7","account-settings-my-profile~admin-home":"3ebac5b9","account-settings-my-profile":"c0e9d97b","admin-home":"e6dd3137","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349":"a16b5a93","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6":"db765b6c","business-guide-concept-distribution":"3bbbff78","business-guide-concept-partners":"18014f85","business-guide-concept-product":"e9a9e3a5","business-guide-concept-promotion":"a6c12d05","business-guide-projections-direct-costs":"04df35ca","business-guide-projections-marketing-budget":"958dc744","business-guide-projections-other-overheads":"a8554666","business-guide-projections-revenue-streams":"07c6f210","business-guide-research-competitors":"60032469","business-guide-research-customers":"028555f7","business-guide-set-up-financing":"72c9c066","business-guide-set-up-staff-and-payroll":"b511ae9a","business-guide-set-up-startup-costs":"9afc18b1","financial-plan-expenses-direct-costs":"5f07269c","financial-plan-expenses-marketing-costs":"87eb77be","financial-plan-expenses-other-overheads":"dffac853","financial-plan-expenses-payroll-expenses":"5476fa49","financial-plan-expenses-startup-costs":"35556546","financial-plan-financing":"0154d41e","financial-plan-profit-and-cash-flow":"ff71eae5","financial-plan-revenue":"e90fc7b2","business-guide-research-market~financial-plan~payment-login~select-idea-new":"84af3266","payment-login":"e8c69cb4","select-idea-new":"afe755e3","home~idea-settings~select-idea":"b4f4569b","home":"ab8351d1","idea-settings":"b9389d1b","select-idea":"f7906875","business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965":"637390b8","business-guide-set-up-management-team":"ed717219","login~signup~verification":"4122bf50","login":"40ec50cd","verification":"789403c1","signup":"f517b132","reset-password":"52608ba7","business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551":"35987728","business-plan-shared":"de34fb7d","business-guide-concept-idea":"e8efe8a0","business-guide-projections-profit-and-cash-flow":"047cebeb","business-guide-research-market-potential":"35bcc547","business-plan":"9fe08e4f","financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared":"27b7e488","financial-plan-overview":"5be561cf","financial-plan-shared":"c46ce370","financial-plan":"1cae4abb","business-guide-ownership":"fb564834","business-guide-research-market":"7798c6ac","idea-plan~shared-journal":"fb829429","idea-plan":"89efdd88","business-guide":"53da6f21","validation-idea-score~validation-idea-score-test":"498647a3","validation-idea-score":"540bb030","validation-idea-score-test":"0325c5f0","ai-assistance":"2ccddab8","app-sumo-signup":"63aa829d","billing":"c5ed75b3","financial-plan-expenses-total-costs":"34e9207a","shared-journal":"5358ab3f","dealify-signup":"37890e38","idea-home":"773ed040","invited-users":"2e225ace","product-tour":"e4050ba7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
